import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { client } from '../client';
import { feedQuery, searchQuery, numUsers} from '../utils/data';
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';

const Feed = () => {
  const [pins, setPins] = useState();
  const [loading, setLoading] = useState(false);
  const { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) {
      setLoading(true);
      const query = searchQuery(categoryId);
      client.fetch(query).then((data) => { //this is the function to fetch data from sanity. V important!
        setPins(data);
        setLoading(false);
      });
    } else {
      setLoading(true);

      client.fetch(feedQuery).then((data) => { //feedQuery is to get ALL the posts, in the situation where there is no category specified
        setPins(data);
        setLoading(false);
        //console.log(data.length)
      });
    }
  }, [categoryId]);

  client.fetch(numUsers).then((data) => { //feedQuery is to get ALL the posts, in the situation where there is no category specified
    console.log(data.length)
  });

  const ideaName = categoryId || 'new';
  
  if (loading) {
    return (
      <Spinner message={`We are adding ${ideaName} ideas to your feed!`} />
    );
  }

  if (!pins?.length) return <h2 className='text-center'>No images available</h2>

  return (
    <div>
      {pins && (
        <MasonryLayout pins={pins} />
      )}
      <div id="itemHolder"><div></div></div>
    </div>
  );
};

export default Feed;